import { render, staticRenderFns } from "./purposition.vue?vue&type=template&id=f0625a96&scoped=true&"
import script from "./purposition.vue?vue&type=script&lang=js&"
export * from "./purposition.vue?vue&type=script&lang=js&"
import style0 from "./purposition.vue?vue&type=style&index=0&id=f0625a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0625a96",
  null
  
)

export default component.exports